import BaseApiRequest from "./BaseApiRequest";
import { PRODUCT_VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ProductVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {};

  constructor(apiBody) {
    super();
    this.body = apiBody;
  }

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(PRODUCT_VAULT_URL);
  };

  getBody = () => this.body;
}
